import { ITranslate } from "@/interfaces/ITranslate";

export const outsourcingTranslate: ITranslate = {
  isOutsourcing: "el valor de subcontrata",
  comments: "los comentarios de subcontrata",
  "outsourcing.isOutsourcing": "el valor de subcontrata",
  "outsourcing.comments": "los comentarios de subcontrata",
};
